import { render, staticRenderFns } from "./UnarchiveEmployeeDialog.vue?vue&type=template&id=6e116a95&scoped=true"
import script from "./UnarchiveEmployeeDialog.vue?vue&type=script&lang=js"
export * from "./UnarchiveEmployeeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e116a95",
  null
  
)

export default component.exports